import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Next_Btn from "../../../../common/common-btn/next-btn/Next_Btn";
import Edit_Trip_Modal from "../../../../edit-trip-modal/Edit_Trip_Modal";
import { formatDate } from "../../../../../utils/common";
import { Context } from "../../../../../utils/context";

const Your_booking_Details = ({ setActiveTab, getBooking }) => {
  const [showModal, setShowModal] = useState(false);

  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);

  const [tripData, setTripData] = useState({
    tripType: "One-way trip",
    fromTo: "Alchi to Leh",
    itinerary: "Alchi - Leh",
    distance: "68 km",
    tripDate: "2026-02-12",
    cabCategory: "Luxury",
    occupancy: "2 passengers and 1 driver",
  });

  const handleNext = () => {
    setActiveTab("conditions");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTripData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    await getBooking()
    setShowModal(false);
  };

  useEffect(() => {
    getBooking();
  }, [setActiveTab]);

  return (
    <section className="Your_booking_Details">
      <div className="booking_card">
        <Row>
          <Col md={10}>
            <div className="booking_info">
              <div className="info_row">
                <span>Trip Type</span>
                <span>:</span>
                <span>{BookingData?.trip_type === "drop" ? "One-way trip" : "Tour"}</span>
              </div>

              <div className="info_row">
                <span>From - To</span>
                <span>:</span>
                <span>{BookingData?.location?.name ?? "Pickup Location"} - {BookingData?.destinationDescription ?? "Drop Location"}</span>
              </div>

              <div className="info_row">
                <span>Itinerary</span>
                <span>:</span>
                <span>{BookingData?.location?.name ?? "Pickup Location"} - {BookingData?.destinationDescription ?? "Drop Location"}</span>
              </div>

              {/* <div className="info_row">
                <span>Total Distance</span>
                <span>:</span>
                <span>{tripData.distance}</span>
              </div> */}

              <div className="info_row mt-3">
                <span>Trip Date</span>
                <span>:</span>
                <span>{formatDate(BookingData?.date)} </span>
              </div>

              <div className="info_row">
                <span>Cab Category</span>
                <span>:</span>
                <span>{BookingData?.cab_type?.cab_category?.name || ""}</span>
              </div>

              <div className="info_row">
                <span>Occupancy</span>
                <span>:</span>
                <span>{BookingData?.cab_type?.seat_capacity?.name || "2"} passengers and 1 driver</span>
              </div>

              <div className="info_row">
                <span>Private Taxi</span>
                <span>:</span>
                <span>
                  the taxi is only for you, it will not be shared with other
                  passengers
                </span>
              </div>
            </div>
          </Col>

          <Col md={2} className="text-end">
            <span
              className="edit_link"
              style={{ cursor: "pointer" }}
              onClick={() => {
                getBooking()
                setShowModal(true)
              }}
            >
              Edit
            </span>
          </Col>
        </Row>
      </div>

      <div className="next_btn_holder my-4" onClick={handleNext}>
        <Next_Btn text="Next" />
      </div>

      <Edit_Trip_Modal
        BookingData={BookingData}
        show={showModal}
        handleClose={() => setShowModal(false)}
        tripData={tripData}
        handleChange={handleChange}
        handleSave={handleSave}
      />
    </section>
  );
};

export default Your_booking_Details;